// eslint-disable -file jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/label-has-associated-control
import React from 'react';
import { publish } from '../publisher';
import './size-and-fit.scss';
import { SizeTable } from '../size-table/SizeTable';

export const SizeAndFit = () => {

  const TYPES = {
    deep_fitted: 'Extra Deep Fitted Sheets',
    deep_flat: 'Extra Deep Flat Sheets',
    duvet: 'Duvet',
    fitted: 'Fitted Sheets',
    flat: 'Flat Sheets',
    oversized_duvet: 'Oversized Duvet',
    pillow: 'Pillowcase',
    sham: 'Sham',
    skirt: 'Bed Skirt'
  };
  const ALL_SIZES = [
    'Twin',
    'Twin XL',
    'Full',
    'Queen',
    'King',
    'California King',
    'Crib'
  ];
  const DEFAULT_PILLOW_SIZES = [
    'Standard',
    'King',
    'Euro'
  ];

  const DEFAULT_PILLOWS = {
    sizes: DEFAULT_PILLOW_SIZES,
    measurements: [
      {
        type: TYPES.pillow,
        values: ['20in. x 30in.', '20 in x 40 in.', ' - ']
      },
      {
        type: TYPES.sham,
        values: [
          '20 in. x 26 in.',
          '20 in. x 36 in.',
          '26 in. x 26 in.',
        ]
      }
    ]
  };

  const sections = [
    {
      title: '210-Thread Count Percale',
      sizes: ALL_SIZES,
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '70 in. x 90 in.',
            '70 in. x 96 in.',
            '84 in. x 90 in.',
            '90 in. x 96 in.',
            '108 in. x 96 in.',
            ' - ',
            ' - ',
          ],
        },
        {
          type: TYPES.flat,
          values: [
            '66 in. x 96 in.',
            ' - ',
            '81 in. x 96 in.',
            '90 in. x 102 in.',
            '108 in. x 102 in.',
            ' - ',
            ' - ',
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '39 in. x 75 in. x 14 in.',
            '39 in. x 80 in. x 14 in.',
            '54 in. x 75 in. x 14 in.',
            '60 in. x 80 in. x 14 in.',
            '78 in. x 80 in. x 14 in.',
            '72 in. x 84 in. x 14 in.',
            (<span>28 in. x 52 in. x 4 in. <br /> 28 in. x 52 in. x 6 in.</span>)
          ]
        }
      ],
      pillows: DEFAULT_PILLOWS
    },
    {
      title: '300-Thread Count Percale',
      sizes: ALL_SIZES.slice(0, ALL_SIZES.length - 1),
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '70 in. x 90 in.',
            '70 in. x 96 in.',
            '84 in. x 90 in.',
            '90 in. x 96 in.',
            '108 in. x 96 in.',
            ' - '
          ]
        },
        {
          type: TYPES.flat,
          values: [
            '66 in. x 96 in.',
            ' - ',
            '81 in. x 96 in.',
            '90 in. x 102 in.',
            '108 in. x 102 in.',
            ' - '
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '39 in. x 75 in. x 14 in.',
            '39 in. x 80 in. x 14 in.',
            '54 in. x 75 in. x 14 in.',
            '60 in. x 80 in. x 14 in.',
            '78 in. x 80 in. x 14 in.',
            '72 in. x 84 in. x 14 in.'
          ]
        },
      ],
      pillows: DEFAULT_PILLOWS
    },
    {
      title: '300-Thread Count Organic Percale',
      sizes: ALL_SIZES.slice(0, ALL_SIZES.length - 2),
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '70 in. x 90 in.',
            ' - ',
            '84 in. x 90 in.',
            '90 in. x 96 in.',
            '108 in. x 96 in.'
          ]
        },
        {
          type: TYPES.flat,
          values: [
            '66 in. x 96 in.',
            ' - ',
            '81 in. x 96 in.',
            '90 in. x 102 in.',
            '108 in. x 102 in.'
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '39 in. x 75 in. x 14 in.',
            '39 in. x 80 in. x 14 in.',
            '54 in. x 75 in. x 14 in.',
            '60 in. x 80 in. x 14 in.',
            '78 in. x 80 in. x 14 in.'
          ]
        }
      ],
      pillows: DEFAULT_PILLOWS
    },
    {
      title: '300-Thread Count Wrinkle-Free Sateen',
      sizes: ALL_SIZES.slice(0, ALL_SIZES.length - 2),
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '70 in. x 90 in.',
            ' - ',
            '84 in. x 90 in.',
            '90 in. x 96 in.',
            '108 in. x 96 in.'
          ]
        },
        {
          type: TYPES.flat,
          values: [
            '66 in. x 96 in.',
            ' - ',
            '81 in. x 96 in.',
            '90 in. x 102 in.',
            '108 in. x 102 in.'
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '39 in. x 75 in. x 14 in.',
            '39 in. x 80 in. x 14 in.',
            '54 in. x 75 in. x 14 in.',
            '60 in. x 80 in. x 14 in.',
            '78 in. x 80 in. x 14 in.'
          ]
        }
      ],
      pillows: DEFAULT_PILLOWS
    },
    {
      title: '350-Thread Count Sateen Solid/Stripe',
      sizes: ALL_SIZES.slice(0, ALL_SIZES.length - 1),
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '70 in. x 90 in.',
            ' - ',
            '84 in. x 90 in.',
            '90 in. x 96 in.',
            '108 in. x 96 in.',
            ' - '
          ]
        },
        {
          type: TYPES.flat,
          values: [
            '66 in. x 96 in.',
            ' - ',
            '81 in. x 96 in.',
            '90 in. x 102 in.',
            '108 in. x 102 in.',
            ' - '
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '39 in. x 75 in. x 14 in.',
            '39 in. x 80 in. x 14 in.',
            '54 in. x 75 in. x 14 in.',
            '60 in. x 80 in. x 14 in.',
            '78 in. x 80 in. x 14 in.',
            '72 in. x 84 in. x 14 in.'
          ]
        },
        {
          type: TYPES.deep_flat,
          values: [
            ' - ',
            ' - ',
            ' - ',
            '90 in. x 108 in.',
            '114 in. x 108 in.',
            '108 in. x 112 in.'
          ]
        },
        {
          type: TYPES.deep_fitted,
          values: [
            ' - ',
            ' - ',
            ' - ',
            '60 in. x 80 in. x 18 in.',
            '78 in. x 80 in. x 18 in',
            '72 in. x 84 in. x 18 in.'
          ]
        },
        {
          type: TYPES.skirt,
          values: [
            '39 in. x 75 in. x 14 in.',
            ' - ',
            '54 in. x 75 in. x 14 in.',
            '60 in. x 80 in. x 14 in.',
            '78 in. x 80 in. x 14 in',
            ' - '
          ]
        }
      ],
      pillows: DEFAULT_PILLOWS
    },
    {
      title: '400-Thread Count Supima Percale',
      sizes: ALL_SIZES.slice(0, ALL_SIZES.length - 1),
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '70 in. x 90 in.',
            ' - ',
            '86 in. x 92 in.',
            '92 in. x 98 in.',
            '110 in. x 98 in.',
            ' - '
          ]
        },
        {
          type: TYPES.flat,
          values: [
            '66 in. x 96 in.',
            ' - ',
            '81 in. x 96 in.',
            '90 in. x 102 in.',
            '108 in. x 102 in.',
            ' - '
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '39 in. x 75 in. x 14 in.',
            ' - ',
            '54 in. x 75 in. x 14 in.',
            '60 in. x 80 in. x 14 in.',
            '78 in. x 80 in. x 14 in.',
            '72 in. x 84 in. x 14 in.'
          ]
        },
        {
          type: TYPES.deep_flat,
          values: [
            ' - ',
            ' - ',
            ' - ',
            '90 in. x 108 in.',
            '114 in. x 108 in.',
            '108 in. x 112 in.'
          ]
        },
        {
          type: TYPES.deep_fitted,
          values: [
            ' - ',
            ' - ',
            ' - ',
            '60 in. x 80 in. x 18 in.',
            '78 in. x 80 in. x 18 in',
            '72 in. x 84 in. x 18 in.'
          ]
        }
      ],
      pillows: DEFAULT_PILLOWS
    },
    {
      title: '450-Thread Count Wrinkle-Free Supima Sateen',
      sizes: ALL_SIZES.slice(0, ALL_SIZES.length - 1),
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '70 in. x 90 in.',
            ' - ',
            '84 in. x 90 in.',
            '90 in. x 96 in.',
            '108 in. x 96 in.',
            ' - '
          ]
        },
        {
          type: TYPES.flat,
          values: [
            '66 in. x 96 in.',
            ' - ',
            '81 in. x 96 in.',
            '90 in. x 102 in.',
            '108 in. x 102 in.',
            ' - '
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '39 in. x 75 in. x 14 in.',
            '39 in. x 80 in. x 14 in.',
            '54 in. x 75 in. x 14 in.',
            '60 in. x 80 in. x 14 in.',
            '78 in. x 80 in. x 14 in.',
            '72 in. x 84 in. x 14 in.'
          ]
        },
        {
          type: TYPES.deep_flat,
          values: [
            ' - ',
            ' - ',
            ' - ',
            '90 in. x 108 in.',
            '114 in. x 108 in.',
            '108 in. x 112 in.'
          ]
        },
        {
          type: TYPES.deep_fitted,
          values: [
            ' - ',
            ' - ',
            ' - ',
            '60 in. x 80 in. x 18 in.',
            '78 in. x 80 in. x 18 in',
            '72 in. x 84 in. x 18 in.'
          ]
        }
      ],
      pillows: DEFAULT_PILLOWS
    },
    {
      title: '500-Thread Count Supima Sateen Solid/Dot',
      sizes: ALL_SIZES.slice(0, ALL_SIZES.length - 1),
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '70 in. x 90 in.',
            ' - ',
            '84 in. x 90 in.',
            '90 in. x 96 in.',
            '108 in. x 96 in.',
            ' - '
          ]
        },
        {
          type: TYPES.oversized_duvet,
          values: [
            ' - ',
            ' - ',
            ' - ',
            '98 in. x 96 in.',
            '116 in. x 96 in.',
            ' - '
          ]
        },
        {
          type: TYPES.flat,
          values: [
            '66 in. x 96 in.',
            ' - ',
            '81 in. x 96 in.',
            '96 in. x 102 in.',
            '108 in. x 102 in.',
            ' - '
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '39 in. x 75 in. x 16 in.',
            '39 in. x 80 in. x 16 in.',
            '54 in. x 75 in. x 16 in.',
            '60 in. x 80 in. x 16 in.',
            '78 in. x 80 in. x 16 in.',
            '72 in. x 84 in. x 16 in.'
          ]
        }
      ],
      pillows: DEFAULT_PILLOWS
    },
    {
      title: '800-Thread Count Egyptian Sateen',
      sizes: ALL_SIZES.slice(2, ALL_SIZES.length - 1),
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '90 in. x 96 in.',
            '108 in. x 96 in.',
            ' - '
          ]
        },
        {
          type: TYPES.flat,
          values: [
            '90 in. x 102 in.',
            '108 in. x 102 in.',
            ' - '
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '60 in. x 80 in. x 16 in.',
            '78 in. x 80 in. x 16 in.',
            '72 in. x 84 in. x 16 in.'
          ]
        }
      ],
      pillows: {
        sizes: DEFAULT_PILLOW_SIZES.concat(['Boudoir']),
        measurements: [
          {
            type: TYPES.pillow,
            values: ['20 in. x 30 in.', '20 in. x 40 in.', ' - ', ' - ']
          },
          {
            type: TYPES.sham,
            values: ['20 in. x 26 in.', '20 in. x 36 in.', '26 in. x 26 in.', '16 in. x 24 in.']
          }
        ]
      }
    },
    {
      title: 'Comfort Wash Linen',
      sizes: ['Twin', 'Full', 'Queen', 'King'],
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '70 in. x 90 in.',
            '84 in. x 90 in.',
            '90 in. x 96 in.',
            '108 in. x 96 in.'
          ]
        },
        {
          type: TYPES.flat,
          values: [
            '66 in. x 96 in.',
            '81 in. x 96 in.',
            '90 in. x 102 in.',
            '108 in. x 102 in.'
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '39 in. x 75 in. x 14 in.',
            '54 in. x 75 in. x 14 in.',
            '60 in. x 80 in. x 14 in.',
            '78 in. x 80 in. x 14 in.'
          ]
        }
      ],
      pillows: DEFAULT_PILLOWS
    },
    {
      title: '5 oz. Flannel',
      sizes: ALL_SIZES.slice(0, ALL_SIZES.length - 1),
      measurements: [
        {
          type: TYPES.duvet,
          values: [
            '70 in. x 90 in.',
            ' - ',
            '84 in. x 90 in.',
            '90 in. x 96 in.',
            '108 in. x 96 in.'
          ]
        },
        {
          type: TYPES.flat,
          values: [
            '66 in. x 96 in.',
            ' - ',
            '81 in. x 96 in.',
            '90 in. x 102 in.',
            '108 in. x 102 in.'
          ]
        },
        {
          type: TYPES.fitted,
          values: [
            '39 in. x 75 in. x 14 in.',
            '39 in. x 80 in. x 14 in.',
            '54 in. x 75 in. x 14 in.',
            '60 in. x 80 in. x 14 in.',
            '78 in. x 80 in. x 14 in.'
          ]
        }
      ],
      pillows: {
        sizes: ['Standard', 'King'],
        measurements: [
          {
            type: TYPES.pillow,
            values: ['20 in. x 30 in.', '20 in. x 40 in.']
          },
          {
            type: TYPES.sham,
            values: ['20 in. x 26 in.', ' - ']
          }
        ]
      }
    },
  ];
  return (
    <div data-section="size-and-fit" className="size-and-fit col__12-12 tabbed-content__tab">
      <div className="col__12-12">
        <section className="accordion__wrapper accordion__wrappera">
          {sections.map((section, sectionIndex) => {
            return (
              <div className="accordion__item" key={sectionIndex}>
                <input
                  className="accordion__input"
                  id={`ac-${sectionIndex + 1}`}
                  name={`accordion-${sectionIndex + 1}`}
                  type="checkbox"
                />
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                <label
                  onClick={(evt) => publish({ itemText: section.title, append: 'accordion ' })}
                  className="accordion__label"
                  htmlFor={`ac-${sectionIndex + 1}`}
                >
                  <div className="accordion__trigger">
                    <div className="accordion__plus" />
                  </div>
                  {section.title}
                </label>
                <div className="accordion__content-wrapper">
                  <div className="accordion__content">
                    <div className="accordion__table">
                      <SizeTable measurements={section.measurements} sizes={section.sizes} />
                    </div>
                    {section.pillows
                    && (
                      <div className="accordion__table">
                        <SizeTable measurements={section.pillows.measurements} sizes={section.pillows.sizes} />
                      </div>
                    )}
                  </div>
                </div>
              </div>

            );
          })}
        </section>
      </div>
    </div>
  );
};

SizeAndFit.displayName = 'SizeAndFit';
